module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "margin-top": "120px"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
  }, [_c('div', {
    staticClass: "box-style line-top"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_vm._m(0), _vm._v(" "), (_vm.invitadoData) ? _c('div', {
    staticClass: "box-text centered margin-top-60"
  }, [_c('h1', {
    staticClass: "open size-22 margin-bottom-40 txt-black"
  }, [_vm._v("Bienvenido "), _c('span', {
    staticClass: "regular",
    attrs: {
      "id": "user_name"
    }
  }, [_vm._v(_vm._s(_vm.invitadoData.firstName) + " " + _vm._s(_vm.invitadoData.lastName))]), _vm._v(" a "), _c('span', {
    staticClass: "black"
  }, [_vm._v("andalepide!")])]), _vm._v(" "), _c('h1', {
    staticClass: "open size-18 margin-bottom-10 txt-black"
  }, [_vm._v("Te pediremos unos datos más y estarás listo")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clear-sm"
  }), _vm._v(" "), (_vm.invitadoData && !_vm.invitadoData.idUsuario) ? _c('form', {
    staticClass: "form smart-form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [(_vm.invitadoData) ? _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Empresa")]), _vm._v(" "), _c('div', {
    staticClass: "input-text"
  }, [_vm._v(_vm._s(_vm.invitadoData.referidor.sucursalAsociada.empresa.razonSocial) + " - " + _vm._s(_vm.invitadoData.referidor.sucursalAsociada.denominacion))])]) : _vm._e()]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.firstName),
      expression: "userData.firstName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.userData.firstName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userData.firstName = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.userData.firstName.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El nombre es requerido")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Apellido")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.lastName),
      expression: "userData.lastName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.userData.lastName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userData.lastName = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.userData.lastName.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El apellido es requerido")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("E-mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.email),
      expression: "userData.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "mail"
    },
    domProps: {
      "value": (_vm.userData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userData.email = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.userData.email.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El email es requerido")]) : _vm._e(), _vm._v(" "), (!_vm.$v.userData.email.email && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Formato de email no válido")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Teléfono")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.telefono),
      expression: "userData.telefono"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.userData.telefono)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userData.telefono = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.password),
      expression: "userData.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.userData.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userData.password = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.userData.password.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El password es requerido")]) : _vm._e(), _vm._v(" "), (!_vm.$v.userData.password.minLength && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("El password debe contener 6 caracteres como mínimo")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Repetir password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.userData.repetirPassword),
      expression: "userData.repetirPassword"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password"
    },
    domProps: {
      "value": (_vm.userData.repetirPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.userData.repetirPassword = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.userData.repetirPassword.sameAs && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("No coincide con el password")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "form-action text-center"
  }, [_c('button', {
    staticClass: "btn btn-fill btn-lg size-16",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.guardar($event)
      }
    }
  }, [_vm._v("GUARDAR Y COMENZAR")])])]) : _c('div', {
    staticClass: "row"
  }, [_c('h1', {
    staticClass: "text-center center-block"
  }, [_vm._v("La invitación ya fue utilizada para crear una cuenta")]), _vm._v(" "), _c('div', {
    staticClass: "text-center center-block"
  }, [_c('router-link', {
    staticClass: "btn btn-fill",
    attrs: {
      "to": "/login"
    }
  }, [_vm._v("Accede ahora a tu cuenta")])], 1)])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bird"
  }, [_c('img', {
    attrs: {
      "src": "/images/bird.png",
      "alt": "Andalepide"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Área de la empresa")]), _vm._v(" "), _c('div', {
    staticClass: "select"
  }, [_c('select', [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Elija...")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Administración")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Atención al cliente")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Comercial")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Contaduría")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Recepción")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("RRHH")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("Comercial")])]), _vm._v(" "), _c('i', {
    staticClass: "fa fa fa-angle-down"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-66ba3f1f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/User/RegistroInvitado.vue
// module id = 1137
// module chunks = 5